import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-55a496fb")

_pushScopeId("data-v-55a496fb")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回上一级")
const _hoisted_4 = { class: "flex flexR mar-t-22" }
const _hoisted_5 = { class: "flex flexR" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "车辆信息", -1)
const _hoisted_7 = {
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_8 = {
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back(-1)))
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            label: "单据编号",
            align: "center",
            "min-width": "80"
          }, {
            default: _withId((scope) => [
              _createVNode("div", {
                class: "c-red mouse_point",
                onClick: ($event: any) => (_ctx.getOrderCarinfo(scope.row.id))
              }, _toDisplayString(scope.row.ordersn), 9, ["onClick"])
            ]),
            _: 1
          }),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              align: "center",
              prop: item.prop,
              label: item.label,
              "min-width": item.width,
              key: index
            }, null, 8, ["prop", "label", "min-width"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "工单详情",
      modelValue: _ctx.detailData.dialogFormVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.detailData.dialogFormVisible = $event)),
      onClosed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.detailData.dialogFormVisible=false)),
      center: "",
      width: 1000
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, { onClick: _ctx.getCarInfo }, {
            default: _withId(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode("table", _hoisted_7, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.detailTable, (items, index) => {
            return (_openBlock(), _createBlock("tr", { key: index }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(items, (item, idx) => {
                return (_openBlock(), _createBlock("td", { key: idx }, _toDisplayString(item), 1))
              }), 128))
            ]))
          }), 128))
        ]),
        (_ctx.detailData.orderDetail.order_offer_project.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: _ctx.detailData.orderDetail.order_offer_project,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummaries(item, 1),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projectColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true),
        (_ctx.detailData.orderDetail.order_offer_mountings.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 1,
              data: _ctx.detailData.orderDetail.order_offer_mountings,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummaries(item, 2),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.partsColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true),
        (_ctx.detailData.orderDetail.mountings_cost.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 2,
              data: _ctx.detailData.orderDetail.mountings_cost,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummaries(item, 3),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mountingsCostColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true),
        (_ctx.detailData.orderDetail.else_cost.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 3,
              data: _ctx.detailData.orderDetail.else_cost,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummaries(item, 4),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.elseCostColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true),
        (_ctx.detailData.orderDetail.settlement.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 4,
              data: _ctx.detailData.orderDetail.settlement,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummaries(item, 5),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.settlementColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "车辆信息",
      modelValue: _ctx.detailData.carInfoDia_show,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.detailData.carInfoDia_show = $event)),
      onClosed: _cache[5] || (_cache[5] = ($event: any) => (_ctx.detailData.carInfoDia_show = false)),
      center: "",
      width: 1000,
      "append-to-body": "true"
    }, {
      default: _withId(() => [
        _createVNode("table", _hoisted_8, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.carInfoTable, (items, index) => {
            return (_openBlock(), _createBlock("tr", { key: index }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(items, (item, idx) => {
                return (_openBlock(), _createBlock("td", { key: idx }, _toDisplayString(item), 1))
              }), 128))
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
})